import {
  createActions
} from 'redux-actions';
import * as Types from './constants';

export default createActions({
  [Types.FIND_USERS_ATTEMPT]: (filters = {}, limit = 5, skip = 0) => ({ filters, limit, skip }),
  [Types.FIND_USERS_SUCCESS]: (data, limit, skip, total) => ({ data, limit, skip, total }),
  [Types.FIND_USERS_FAILURE]: (error) => ({ error }),
  [Types.REMOVE_USER_ATTEMPT]: (id) => ({ id }),
  [Types.REMOVE_USER_SUCCESS]: (id) => ({ id }),
  [Types.REMOVE_USER_FAILURE]: (error) => ({ error }),
  [Types.CHANGE_USER_FORM_VALUE]: (name, value) => ({ name, value }),
  [Types.RESET_USER_FORM]: () => ({}),
  [Types.FILL_USER_FORM]: (values) => ({ values }),
  [Types.TOGGLE_USER_UPSERT_MODAL]: () => ({}),
  [Types.TOGGLE_USER_FILTERS_MODAL]: () => ({}),
  [Types.SET_USERS_FILTER]: (name, value) => ({ name, value }),
  [Types.UPSERT_USER_ATTEMPT]: (values) => ({ values }),
  [Types.SELECT_USER]: (user) => ({ user }),
  [Types.UPSERT_USER_SUCCESS]: (user) => ({ user }),
  [Types.UPSERT_USER_FAILURE]: (error) => ({ error })
});


// WEBPACK FOOTER //
// ./client/store/actions/usersActions.js